export enum PersonTypes {
  PROFESSIONAL = 2,
  EMPLOYEE = 3,
  DELETED = 4,
  INTERNATIONAL_AMATEUR = 5,
  DOMESTIC_AMATEUR = 6,
  DRUG_TEST = 7,
  PARTNER_PORTAL = 8,
}

export enum EmployeeLevels {
  MAJOR_LEAUGE = 1,
  MINOR_LEAGUE = 2,
  AAA = 3,
  AA = 4,
  A_PLUS = 5,
  A = 6,
  SA = 7,
  RA = 8,
  R = 9,
  VSL = 10,
  DSL = 11,
  NONE = 12,
  NON_BASEBALL_OPS = 13,
}

export enum RosterStatus {
  ACTIVE = 9,
  DECEASED = 15,
}

export enum EmployeeRosterStatus {
  ACTIVE = 1,
  FREE_AGENT = 2,
  INELIGIBLE = 3,
  SUSPENDED = 4,
  ACTIVE_NOT_UNDER_CONTROL = 5,
  TEMP_INACTIVE = 6,
  DECEASED = 7,
}
